import { PREMIUM_APPS, PROFESSIONAL } from "@/lib/tiers";

/**
 * The single buy link shown on phones in place of the two Quick Buy rows. The tier decides the prices
 * (owner rule, Nov 1 2026): Professional Tools "$1 day pass · $4.99/month"; Premium Applications (Budget, Shopping
 * List, Invoice, Sign PDF and the other apps) "$3 day pass · $9.99/month". Workflow Products get no pass link: the
 * strip does not render for them. "Ad-free", not "Ads-free", so the visible-copy rule on the word "free" holds.
 */
export function mobileBuyLinkText(premium: boolean): string {
  const t = premium ? PREMIUM_APPS : PROFESSIONAL;
  return `Ad-free: ${t.dayPass} day pass · ${t.monthly}/month`;
}
